import React from "react";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";
import useFormFlow from "modules/forms/hooks/useFormFlow";
import Checkbox from "modules/forms/embedded/formElements/Checkbox";
import BlockWrapper from "modules/forms/embedded/blocks/BlockWrapper";

export type SubscriptionTypeBlockType = Omit<FormBlockType, "data"> & {
    data: {
        label: string;
        hidden: boolean;
        description: string;
    },
}

export default function SubscriptionTypeBlock(block: SubscriptionTypeBlockType) {
    const { values, onChange } = useFormFlow();

    return (
        <BlockWrapper hidden={block.data.hidden} name={block.name}>
            <Checkbox
                {...block.data}
                id={block.uuid}
                name={block.name}
                label={block.data.label}
                checked={values[block.name] ?? false}
                onChange={checked => onChange(block.name, checked)}
            />
        </BlockWrapper>
    );
}
